var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "expand-thin",
  "use": "expand-thin-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"expand-thin\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-61-17H39v50H-61z\" /><path stroke=\"#DBDBDB\" d=\"M-61.5-17.5h101v51h-101z\" /><path stroke=\"#888\" stroke-linecap=\"round\" d=\"M1 4l6 6 6-6\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol